import { usePermission } from '../../hooks/usePermission'
import { useMe } from '../hooks/useMe'
import { AccessDeniedPage } from './AccessDeniedPage'
import { LoadingSpinner } from './LoadingSpinner'
import type { Permission } from '../../types'

interface RequirePermissionProps {
  permission: Permission
  children: React.ReactNode
}

export function RequirePermission({ permission, children }: RequirePermissionProps) {
  const { data: me, isLoading } = useMe()
  const { can } = usePermission()

  // Don't flash "Access Denied" while permissions are loading
  if (isLoading || !me) return <LoadingSpinner message="Checking permissions..." />

  if (!can(permission)) {
    return <AccessDeniedPage />
  }

  return <>{children}</>
}
